/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Helmet } from 'react-helmet-async';
import { useMatches } from 'react-router-dom';

interface RouteTitleProps {
  t: any;
  children: React.ReactNode;
}

interface RouteHandle {
  title?: string;
}

const RouteTitle: React.FC<RouteTitleProps> = ({ t, children }) => {
  const matches = useMatches();

  const routeWithTitle = matches.find(
    (match) => (match.handle as RouteHandle)?.title,
  );
  const titleKey = (routeWithTitle?.handle as RouteHandle)?.title;
  const title = titleKey ? t(titleKey as any) : 'agrantis';

  return (
    <>
      <Helmet>
        <title>
          {title !== 'agrantis' ? `${title} | agrantis` : 'agrantis'}
        </title>
      </Helmet>
      {children}
    </>
  );
};

export default RouteTitle;
